import { render } from "./photo-page.vue?vue&type=template&id=198a00da&scoped=true&ts=true"
import script from "./photo-page.ts?vue&type=script&lang=ts&external"
export * from "./photo-page.ts?vue&type=script&lang=ts&external"

import "./photo-page.less?vue&type=style&index=0&id=198a00da&lang=less&scoped=true&external"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-198a00da"]])

export default __exports__
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInnerLoading,QSpinner,QBtn,QIcon,QTooltip});
